<template>
    <div class="container">
        <div class="selftest" :class="{'continue-button-padding': displayNext}">
            <div class="answer-container">
                <div class="level-1 ui-droppable">
                    <div class="color-tag level-neon-bar"><img src="images/selftest/Emotions-01.svg"></div>
                    <div class="drop-container ">
                    </div>
                </div>
                <div class="level-2 ui-droppable">
                    <div class="color-tag level-neon-bar"><img src="images/selftest/Emotions-02.svg"></div>
                    <div class="drop-container">
                    </div>
                </div>
                <div class="level-3 ui-droppable">
                    <div class="color-tag level-neon-bar"><img src="images/selftest/Emotions-03.svg"></div>
                    <div class="drop-container">
                    </div>
                </div>
                <div class="level-4 ui-droppable">
                    <div class="color-tag level-neon-bar"><img src="images/selftest/Emotions-04.svg"></div>
                    <div class="drop-container">
                    </div>
                </div>
                <div class="level-5 ui-droppable">
                    <div class="color-tag level-neon-bar"><img src="images/selftest/Emotions-05.svg"></div>
                    <div class="drop-container">
                    </div>
                </div>                
            </div>
            <div class="question-main">
                <div ref="questionContainer" class="question-container">                
                </div>
                <div class="explanation-wrapper">
                    <span v-if="!allQuestionsAnswered" class="explanation">
                        rank je skills <div class="circle">{{currentQuestionIndex}}/{{data.length}}</div>
                    </span>
                    <span v-if="allQuestionsAnswered" class="explanation">
                        Je kan nog steeds je skills schuiven.
                    </span>
                    <span v-if="allQuestionsAnswered" class="explanation">
                        Raak een box aan om de uitleg nog 'n keer te zien.
                    </span>
                </div>
            </div>
        </div>        
        <div v-show="displayNext" class="continue-button-overlay">
            <span @click.prevent="onNext" class="continue-button">Verder ></span>
        </div>
        <div v-show="displayExplanation" ref="explanationOverlay" class="explanation-overlay" @click.prevent="hideExplanation" v-touch:swipe="hideExplanation">
            <div ref="handAnim" id="hand"></div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import QuestionComponent from './SelfTest/QuestionComponent.vue';

    import Audio from '../../services/Audio';

    import Helper from '../../services/Helper';

    export default {
        'props': {
            data: {}
        },
        'data': function() {
            return {
                displayExplanation: true,
                levels: null,
                currentQuestionIndex: 0,
                currentQuestion: null,
                total: 0,
                displayNext: false,
                allQuestionsAnswered: false,
            }
        },
        watch: {
            data: {
                handler(newVal, oldVal) {
                    if(oldVal[0].collection != newVal[0].collection) {
                        this.cleanup();
                    }
                }
            }
        },
        'methods': {
            'hideExplanation': function () {
                this.displayExplanation = false;
                sessionStorage.viewedSelfTestExplanation = true;
            },
            'cleanup': function() {
                $('[id^="drag"]').remove();
                
                this.currentQuestionIndex = 0;
                this.currentQuestion = null;
                this.displayNext = false;
                this.allQuestionsAnswered = false;

                this.setupNextQuestion();
            },
            'onNext': function() {
                let ids = [];
                let answers = [];
                $('[id^="drag"]').each((index, value) => {
                    let id = $(value).attr('id');
                    id = id.substring(4, id.length);
                    
                    answers.push({ 
                        questionId: id, 
                        answer: index + 1,
                    });
                });

                this.$emit('answer', answers);

                setTimeout(() => {
                    this.displayNext = false;
                    this.$emit('complete', true);
                    //this.$emit('next');
                });
            },
            'onClickDroppable': function(event) {
                event.preventDefault();

                Audio.playSFX('swoosh-out');

                var dragElement = $('.question-container').find('.draggable')[0];
                $(event.currentTarget).find('.drop-container').append(dragElement);

                $(dragElement).css({
                    top: "0px",
                    left: "0px",
                    'z-index': ''
                });

                let $parent = $(event.currentTarget);
                let targetIndex = -1;
                let moveUp = true;

                this.levels.forEach((level, index) => {
                    if($parent.get(0) == level.get(0)) {
                        targetIndex = index;
                    }

                    if(moveUp == true 
                        && targetIndex != -1 
                        && targetIndex != index 
                        &&  index - targetIndex > 0) {
                        moveUp = this.levels[index].find('.draggable').length >= 2;
                    }
                })

                if (targetIndex == -1) {
                    return;
                }
                
                this.moveQuestionElement(dragElement, targetIndex, moveUp, true);
                
                this.setupNextQuestion();
            },
            'drop': function(event, ui) {

                event.preventDefault();

                Audio.playSFX('swoosh-out');

                var dragElement = ui.draggable.get(0);
                $(event.target).find('.drop-container').append(dragElement);

                $(dragElement).css({
                    top: "0px",
                    left: "0px",
                    'z-index': ''
                });

                let $parent = $(event.target);
                let targetIndex = -1;
                let moveUp = true;

                this.levels.forEach((level, index) => {
                    if($parent.get(0) == level.get(0)) {
                        targetIndex = index;
                    }

                    if(moveUp == true 
                        && targetIndex != -1 
                        && targetIndex != index 
                        &&  index - targetIndex > 0) {
                        moveUp = this.levels[index].find('.draggable').length >= 2;
                    }
                })

                if (targetIndex == -1) {
                    return;
                }
                
                this.moveQuestionElement(dragElement, targetIndex, moveUp, true);
                
                this.setupNextQuestion();
            },
            'moveQuestionElement': function(el, index, moveUp, isFirst = false) {
                if(isFirst || moveUp) {
                    this.levels[index].find('.drop-container').append(el);
                } else {
                    this.levels[index].find('.drop-container').prepend(el);
                }
                
                if(this.levels[index].find('.draggable').length > 2) {
                    if(moveUp) {
                        el = this.levels[index].find('.draggable').get(0);
                    } else {
                        el = this.levels[index].find('.draggable').get(1);
                    }
                    
                    this.moveQuestionElement(el, (moveUp) ? index - 1 : index + 1, moveUp, false);
                }
            },
            'setupNextQuestion': function() {

                if(this.currentQuestionIndex >= this.data.length && this.$refs.questionContainer.children.length == 0) {
                    this.displayNext = true;
                    this.allQuestionsAnswered = true;
                    return;
                }

                if(this.$refs.questionContainer.children.length >= 1) {
                    return;
                }

                this.currentQuestion = this.data[this.currentQuestionIndex].question;

                let ComponentClass = Vue.extend(QuestionComponent);
                let instance = new ComponentClass({
                    propsData: {
                        id: this.currentQuestion.id,
                        title: this.currentQuestion.title,
                        text: this.currentQuestion.text,
                    }
                });

                instance.$mount();
                $(instance.$el).draggable({
                    appendTo: '.question-container',
                    connectToSortable: ".drop-container",
                    revert: 'invalid',
                    opacity: 1,
                    //axis: 'y',
                    stack: '.skill',
                    distance: 10
                });
                this.$refs['drag'+this.currentQuestion.id] = instance;
                this.$refs.questionContainer.appendChild(instance.$el);

                this.currentQuestionIndex++;

                // setTimeout(() => {
                //     window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
                // });
            },
        },
        'mounted': function() {
            this.setupNextQuestion();

            this.levels = [
                $('.level-1'),
                $('.level-2'),
                $('.level-3'),
                $('.level-4'),
                $('.level-5'),
            ];

            $('.ui-droppable').droppable({
                hoverClass: 'drop-hover',
                drop: this.drop
            });

            $('.ui-droppable').click(this.onClickDroppable);

            let animation = lottie.loadAnimation({
                container: this.$refs.explanationOverlay,
                autoplay: true,
                loop: true,
                renderer: 'svg',
                path: "./images/selftest/hand.json",
            });

            this.displayExplanation = !sessionStorage.viewedSelfTestExplanation;

            //Helper.disableTouchMove();
        },
        beforeDestroy() {
            //Helper.enableTouchMove();
        }
    }
</script>
